const state = {
  drawer: null,
}

export default state
